import React, { useState } from 'react';

import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
import Grid from "@mui/material/Grid";
import DashboardCard16 from '../../partials/dashboard/DashboardCard16';
import DashboardCard16region from '../../partials/dashboard/DashboardCard16region';
import Banner from '../../partials/Banner';

function Regions() {

    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-screen overflow-hidden">

            {/* Sidebar */}
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            {/* Content area */}
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                {/*  Site header */}
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main className="grow">
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        <div className="w-full grid grid-cols-12 gap-4 justify-center">
                            <div className="col-span-12 md:col-span-6 lg:col-span-6 xl:col-span-6 w-full">
                                <DashboardCard16 />
                            </div>

                            <div className="col-span-12 md:col-span-6  xs:pb-10 lg:col-span-6 xl:col-span-6 w-full">
                                <DashboardCard16region />
                            </div>
                        </div>

                    </div>
                </main>
                <Banner />
            </div>
        </div>
    );
}

export default Regions;